import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

/**
 * Invalidates every zone and space query. Use after creating, updating or
 * deleting a zone, overriding a space's area, or saving a floor map (which
 * re-syncs the floor's regions).
 */
export const useInvalidateZones = () => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await queryClient.invalidateQueries({ queryKey: ["useZonesQuery"] });
    await queryClient.invalidateQueries({ queryKey: ["useZonesTreeQuery"] });
    await queryClient.invalidateQueries({ queryKey: ["useZonesHealthQuery"] });
    await queryClient.invalidateQueries({ queryKey: ["useZoneQuery"] });
    await queryClient.invalidateQueries({ queryKey: ["useFloorSpacesQuery"] });
    await queryClient.invalidateQueries({
      queryKey: ["useResourcePlacementQuery"]
    });
  }, [queryClient]);
};
